import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from "@/store";
import HeartbeatService from '@/services/HeartbeatService';
import {
	canAccessDebugDistribuidor,
	isFichajesOnly,
	isWorkingHoursPath,
	resolveAlbaranAccessRedirect,
	resolveNominaAccessRedirect,
	resolveInvoiceApprovalAccessRedirect,
} from './router/guards';
import SupplierReceptorSelector from './modules/facturae/infra/SupplierReceptorSelector.vue';
import {
	finishNominaViewTransition,
	shouldCancelNominaTransition,
} from './modules/nominas/app/nominaViewTransition';



Vue.use(Router)

function default_page(to, from, next) {
	//next("/documents");
	// Initially load a list of countries
	// This can be done on a function that 
	// setups the initial data of the app
	// if (!store.getters["countries/countriesLoaded"]) {
	// 	store.dispatch("countries/getCountries")
	// }
	if ("about_expiry" in to.query) {
		next({path:"/initial", query: {about_expiry: true}});
	}
	else {
		next("/initial");
	}
}

function staff_only(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				if (!store.state["me"].userData.is_staff) {
					next("/initial");
				} else {
					next();
				}
			})
		} else {
			// Sin esto el guard nunca llama a next() cuando el usuario no
			// está logueado y la SPA se queda en "loading…" eterno.
			next("/login");
		}
	})
}

function staff_or_loginas(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				let userData = store.state["me"].userData
				let state = store.state
				if (userData && (userData.is_staff || (state.session_information && userData.username && state.session_information.username != userData.username))) {
					next();
				} else {
					next("/initial");
				}
			})
		}
	})
}

function admin_only(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				let userData = store.state["me"].userData
				// Check if user_type is 'admin' or 'administrator'
				if (userData && (userData.user_type === 'admin' || userData.user_type === 'administrator')) {
					next();
				} else {
					// Redirect non-admin users to working hours main view
					// Get companydb_id from route params or use a default
					const companyId = to.params.companydb_id || (store.state.me && store.state.me.selectedCompanyId) || '1';
					next(`/${companyId}/working-hours`);
				}
			})
		} else {
			next("/login");
		}
	})
}

async function hide_restricted_modules_for_albaran_users(to, from, next) {
	const companyId = Number(to.params.companydb_id);
	try {
		const access = await store.dispatch('permissions/loadAlbaranAccess', companyId);
		if (!access.enabled || access.role === 'owner') {
			next();
			return;
		}
	} catch (error) {
		// Access remains denied when the policy cannot be loaded.
	}
	next(`/${companyId}/albaran-factura-list?tab=albaranes`);
}

function distribuidor_avanzado_only(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				let userData = store.state["me"].userData
				if (canAccessDebugDistribuidor(userData)) {
					next();
				} else {
					next("/initial");
				}
			})
		} else {
			next("/login");
		}
	})
}

export const CONTRACTS_KPI_ALLOWED_USERS = [
	'test.toni', 'support.biel', 'support.narcis'
];

function onboard_allowed_only(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				let userData = store.state["me"].userData;
				let session_information = store.state.session_information;
				const i_am_loginas = userData.hasOwnProperty('username') &&
					session_information.hasOwnProperty('username') &&
					(session_information.username != userData.username);
				// Solo permitir si tiene rol de onboard (lo da el backend en
				// get_user_data, desde ddd/onboarding) Y NO es login as
				if (userData && userData.onboard_role && !i_am_loginas) {
					next();
				} else {
					next("/initial");
				}
			})
		} else {
			next("/login");
		}
	})
}

function contracts_kpi_allowed_only(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				let userData = store.state["me"].userData;
				let session_information = store.state.session_information;
				const i_am_loginas = userData.hasOwnProperty('username') &&
					session_information.hasOwnProperty('username') &&
					(session_information.username != userData.username);
				// Solo permitir si está en allowed users Y NO es login as
				if (userData && CONTRACTS_KPI_ALLOWED_USERS.includes(userData.username) && !i_am_loginas) {
					next();
				} else {
					next("/initial");
				}
			})
		} else {
			next("/login");
		}
	})
}

function staff_only_or_staff_loginas(to, from, next) {
	store.dispatch("waitForLoggedIn").then(isLogged => {
		if (isLogged) {
			store.dispatch("me/refreshUserData").then(() => {
				let userData = store.state["me"].userData
				// Caso 1: Usuario actual es staff
				const isCurrentUserStaff = userData && userData.is_staff;
				// Caso 2: Usuario original (session_user) es staff que hizo loginas
				const isSessionUserStaff = userData &&
					userData.session_user &&
					userData.session_user.is_staff;

				if (isCurrentUserStaff || isSessionUserStaff) {
					next();
				} else {
					next("/initial");
				}
			})
		} else {
			next("/login");
		}
	})
}

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			beforeEnter: default_page
		},
		{
			path: '/welcome',
			name: 'welcome',
			component: () => import('./views/WelcomeSteps.vue')
		},
		{
			// Página pública de tarifas. Se inyecta en un iframe desde la web
			// (HubSpot) para reemplazar la tabla de precios estática. Como es
			// el mismo SPA, si el visitante ya está logueado se le muestran
			// los precios de cliente; si no, los públicos.
			path: '/tarifas',
			name: 'tarifas',
			component: () => import('./views/Tarifas.vue')
		},
		// {
		// 	path: '/update',
		// 	name: 'update',
		// 	component: () => import('./views/UpdateProcess.vue')
		// },
		// {
		// 	path: '/about',
		// 	name: 'about',
		// 	// route level code-splitting
		// 	// this generates a separate chunk (about.[hash].js) for this route
		// 	// which is lazy-loaded when the route is visited.
		// 	component: () =>
		// 		import(/* webpackChunkName: "about" */ './views/About.vue')
		// },
		{
			path: '/login',
			name: 'login',
			component: () => import('./views/Login.vue')
		},
		{
			path: '/:white_brand/login', 
			name: 'white_brand',
			component: () => import('./views/Login.vue'),
		},
		{
			path: '/signup/:distributor_code?',
			name: 'signup',
			component: () => import('./views/SignUp.vue')
		},
		{
			path: '/signup-2',
			name: 'signup-2',
			component: () => import('./views/SignUp2.vue')
		},
		{
			path: '/password/reset',
			name: 'password-reset',
			component: () => import('./views/PasswordReset.vue')
		},
		{
			path: '/password/reset/key/:uidb36-:key',
			name: 'password-reset-key',
			component: () => import('./views/PasswordResetKey.vue')
		},
		{
			path: '/confirm-email',
			name: 'confirm-email',
			component: () => import('./views/ConfirmEmail.vue')
		},
		{
			path: '/install-schedule',
			name: 'install-schedule',
			component: () => import('./views/InstallSchedule.vue')
		},
		{
			path: '/connectors',
			name: 'connectors',
			component: () => import('./views/ConnectorList.vue')
		},
		{
			path: '/connectors2',
			name: 'connectors2',
			component: () => import('./views/Connector2List.vue')
		},
		{
			path: '/create-connector',
			name: 'connector-create',
			component: () => import('./views/ConnectorDetail.vue'),
			props: true
		},
		{
			path: '/connector/:id',
			name: 'connector-update',
			component: () => import('./views/ConnectorDetail.vue'),
			props: true
		},
		{
			path: '/user-configuration',
			name: 'user-configuration',
			component: () => import('./views/UserConfiguration.vue')
		},
		{
			path: '/profile',
			name: 'profile',
			component: () => import('./views/Profile.vue')
		},
		{
			path: '/mis-gastos',
			name: 'mis-gastos',
			component: () => import('./views/MisGastos.vue'),
			beforeEnter: (to, from, next) => {
				// Mis Gastos solo tiene sentido con el sistema de créditos
				// (CreditExpense). Si la feature no está activa, redirigimos.
				store.dispatch("waitForLoggedIn").then(isLogged => {
					if (!isLogged) return next("/login");
					store.dispatch("me/refreshUserData").then(() => {
						if (store.getters.got_feature('feature_credit_expense')) {
							next();
						} else {
							next("/initial");
						}
					});
				});
			}
		},{
			path: '/dashboard',
			name: 'dashboard',
			component: () => import('./views/DashboardCompanyDB.vue')

		},
  {
			path: '/:companydb_id/dashboard',
			name: 'company-dashboard',
			component: () => import('@/views/DashboardKpis.vue'),
			props: true
		},
		{
			path: '/dashboard-bank',
			name: 'dashboard-bank',
			component: () => import('./views/DashboardBank.vue')
		},
		{
			path: '/dashboard-gestor',
			name: 'dashboard-gestor',
			component: () => import('./views/DashboardGestor.vue')
		},
		// {
		// 	path: '/loginas/:username',
		// 	name: 'loginas-dashboard',
		// 	component: () => import('./views/DashboardCompanyDB.vue'),
		// 	props: true
		// },

		{
			path: '/kpis',
			name: 'kpis',
			component: () => import('./views/KPIS.vue'),
			beforeEnter: staff_only
		},
		{
			path: '/features',
			name: 'features',
			component: () => import('./views/FeaturesVisualizer.vue'),
			beforeEnter: staff_only_or_staff_loginas
		},
		{
			path: '/tarifas-management',
			name: 'tarifas-management',
			component: () => import('./views/TarifasManagement.vue'),
			beforeEnter: staff_only
		},
		{
			path: '/client-tarifa',
			name: 'client-tarifa',
			props: true,
			component: () => import('./views/ClientTarifa.vue'),
			beforeEnter: staff_or_loginas
		},
		{
			path: '/modules',
			name: 'modules',
			component: () => import('./views/ModuleManager.vue'),
			beforeEnter: staff_only
		},
		{
			path: '/:companydb_id/invoice-trial',
			name: 'invoice-trial',
			component: () => import('./views/InvoiceTrial.vue'),
			props: true
		},
		{
			path: '/:companydb_id/working-hours-trial',
			name: 'working-hours-trial',
			component: () => import('./views/WorkingHoursTrial.vue'),
			props: true
		},
		{
			path: '/:companydb_id/invoice-list',
			name: 'invoice-list',
			component: () => import('./views/InvoiceList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/account-move-list',
			name: 'account-move-list',
			component: () => import('./views/AccountMoveList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/albaran-factura-list',
			name: 'albaran-factura-list',
			component: () => import('./views/AlbaranFacturaList.vue'),
			props: true,
			meta: {
				albaranAccess: {
					viewAction: 'albaran_view',
					deniedRedirect: '/initial',
				},
			},
		},
		{
			path: '/:companydb_id/remesas',
			name: 'remesas',
			component: () => import('./views/Remesas.vue'),
			props: true
		},
		{
			path: '/:companydb_id/nominas',
			name: 'nominas',
			component: () => import('./views/NominaList.vue'),
			props: true,
			meta: {
				nominaAccess: {
					viewAction: 'nomina_view',
					deniedRedirect: '/initial',
					// El módulo solo está implementado contra A3 (`feature_nominas` es de
					// tipo conector): al resto se le explica en vez de esconderle el botón.
					featureRedirect: '/nominas-no-disponible',
				},
			},
		},
		{
			// Sin guard de feature: es justo la pantalla a la que manda ese guard, y
			// protegerla con lo mismo que la provoca sería un bucle.
			path: '/:companydb_id/nominas-no-disponible',
			name: 'nominas-not-available',
			component: () => import('./views/NominaNotAvailable.vue'),
			props: true,
			meta: {
				nominaAccess: {
					viewAction: 'nomina_view',
					deniedRedirect: '/initial',
				},
			},
		},
		{
			path: '/:companydb_id/nominas/papelera',
			name: 'nominas-papelera',
			component: () => import('./views/NominaTrashList.vue'),
			props: true,
			meta: {
				nominaAccess: {
					// Ver la papelera es ver nóminas. Restaurar exige más, y eso lo
					// comprueba el comando (`nomina_delete`).
					viewAction: 'nomina_view',
					deniedRedirect: '/initial',
				},
			},
		},
		{
			// Antes que `/nominas/:uuid`, igual que la papelera: si no, «configuracion»
			// se tomaría por el uuid de una nómina.
			path: '/:companydb_id/nominas/configuracion',
			name: 'nominas-configuracion',
			component: () => import('./views/NominaCompanySettings.vue'),
			props: true,
			meta: {
				nominaAccess: {
					// Verla es ver nóminas. Guardar exige poder editar la ficha de la
					// empresa, y eso lo comprueba el comando (`nomina.save_company_settings`).
					viewAction: 'nomina_view',
					deniedRedirect: '/initial',
					// Se llega desde la barra lateral, no desde el listado: la comprobación
					// del conector no la ha hecho nadie antes.
					featureRedirect: '/nominas-no-disponible',
				},
			},
		},
		{
			path: '/:companydb_id/nominas/:uuid',
			name: 'nomina-detail',
			component: () => import('./views/NominaDetail.vue'),
			props: true,
			meta: {
				nominaAccess: {
					viewAction: 'nomina_view',
					deniedRedirect: '/initial',
				},
			},
		},
		{
			path: '/:companydb_id/empleados',
			name: 'empleados',
			component: () => import('./views/EmpleadoList.vue'),
			props: true,
			meta: {
				nominaAccess: {
					viewAction: 'empleado_view',
					deniedRedirect: '/initial',
				},
			},
		},
		{
			path: '/:companydb_id/empleados/:uuid',
			name: 'empleado-detail',
			component: () => import('./views/EmpleadoDetail.vue'),
			props: true,
			meta: {
				nominaAccess: {
					viewAction: 'empleado_view',
					deniedRedirect: '/initial',
				},
			},
		},
		{
			path: '/:companydb_id/albaran-editor/:albaran_id?',
			name: 'albaran-editor',
			component: () => import('./views/AlbaranEditor.vue'),
			props: true,
			meta: {
				albaranAccess: {
					viewAction: 'albaran_view',
					createAction: 'albaran_edit',
					resourceParam: 'albaran_id',
				},
			},
		},
		{
			path: '/:companydb_id/factura-editor/:factura_id?',
			name: 'factura-editor',
			component: () => import('./views/FacturaEditor.vue'),
			props: true,
			meta: {
				albaranAccess: {
					viewAction: 'factura_view',
					createAction: 'factura_manage',
					resourceParam: 'factura_id',
				},
			},
		},
		{
			path: '/:companydb_id/pedido-list',
			name: 'pedido-list',
			component: () => import('./views/PedidoList.vue'),
			props: true,
			meta: { albaranAccess: { viewAction: 'pedido_view', isPedidosRequired: true } },
		},
		{
			path: '/:companydb_id/pedido-editor/:pedido_id',
			name: 'pedido-editor',
			component: () => import('./views/PedidoEditor.vue'),
			props: true,
			meta: {
				albaranAccess: {
					viewAction: 'pedido_view',
					isPedidosRequired: true,
				},
			},
		},
		{
			path: '/:companydb_id/product-catalog-list',
			name: 'product-catalog-list',
			component: () => import('./views/ProductCatalogList.vue'),
			props: true,
			meta: { albaranAccess: { viewAction: 'catalog_view' } },
		},
		{
			path: '/:companydb_id/product-catalog-editor/:product_id?',
			name: 'product-catalog-editor',
			component: () => import('./views/ProductCatalogEditor.vue'),
			props: true,
			meta: {
				albaranAccess: {
					viewAction: 'catalog_view',
					isCatalogWriteRequired: true,
				},
			},
		},
		{
			// Sin enlace desde la interfaz mientras se valida: se entra escribiendo la URL. El
			// guard sigue mandando, asi que conocerla no basta para ver el gasto de otro.
			path: '/:companydb_id/spend-dashboard',
			name: 'spend-dashboard',
			component: () => import('./views/SpendDashboard.vue'),
			props: true,
			meta: { albaranAccess: { viewAction: 'factura_view' } },
		},
		{
			path: '/:companydb_id/budget-list',
			name: 'budget-list',
			component: () => import('./views/BudgetList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/delivery-note-list',
			name: 'delivery-note-list',
			component: () => import('./views/DeliveryNoteList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/proforma-list',
			name: 'proforma-list',
			component: () => import('./views/ProformaList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/ticket-list',
			name: 'ticket-list',
			component: ()=> import('./views/TicketList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/auto-invoice-list',
			name: 'auto-invoice-list',
			component: ()=> import('./views/AutoInvoiceList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/invoice-editor/:invoice_id?',
			name: 'invoice-editor',
			component: () => import('./views/InvoiceEditor.vue'),
			props: true
		},
		{
			path: '/:companydb_id/budget-editor/:budget_id?',
			name: 'budget-editor',
			component: () => import('./views/BudgetEditor.vue'),
			props: true
		},
		{
			path: '/:companydb_id/delivery-note-editor/:delivery_note_id?',
            name: 'delivery-note-editor',
            component: () => import('./views/DeliveryNoteEditor.vue'),
            props: true
		},
		{
			path: '/:companydb_id/proforma-editor/:proforma_id?',
			name: 'proforma-editor',
			component: () => import('./views/ProformaEditor.vue'),
			props: true
		},
		{
			path: '/:companydb_id/ticket-editor/:ticket_id?',
			name: 'ticket-editor',
			component: () => import('./views/TicketEditor.vue'),
			props: true
		},
		{
			path: '/:companydb_id/auto-invoice-editor/:auto_invoice_id?', 
			name: 'auto-invoice-editor',
			component: () => import('./views/AutoInvoiceEditor.vue'),
			props: true
		},
		{
			path: '/:companydb_id/invoice-to-print/:invoiceable_id',
			name: 'invoice-to-print',
			component: () => import('./views/InvoiceToPrint.vue'),
			//beforeEnter: staff_only
			props: true
		},
		{
			path: '/report-invoice',
            name: 'report-invoice',
            component: () => import('./modules/facturae/infra/pdf_view/ReportFacturae.vue'),
			// beforeEnter: staff_only,
			props: true
		},
		{
			path: '/report-invoice-dynamic',
            name: 'report-invoice-dynamic',
            component: () => import('./modules/facturae/infra/pdf_view/ReportFacturaeDynamic.vue'),
			// beforeEnter: staff_only,
			props: true
		},
		{
			path: '/report-otorgamiento',
            name: 'report-otorgamiento',
            component: () => import('./modules/company/infra/pdf_otorgamiento_repr_generator/ReportOtorgamientoRep.vue'),
			// beforeEnter: staff_only,
			props: true
		},
		{
			// Ruta pública: la abre el destinatario del email de reclamación, sin sesión en Inmatic.
			path: '/bank_claim_doc',
			name: 'bank-claim-doc',
			component: () => import('./views/BankDocumentationClaim.vue'),
			props: true
		},
		{
			path: '/:companydb_id/recurring-invoice-list',
			name: 'recurring-invoice-list',
			component: () => import('./modules/facturae/infra/RecurringInvoiceList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/recurring-invoice-editor/:recurring_invoice_id?',
			name: 'recurring-invoice-editor',
			component: () => import('./modules/facturae/infra/RecurringInvoiceEditor.vue'),
			props: true
		},
		{
			path: '/reports',
            name: 'reports',
            component: () => import('./modules/reporting/infrastructure/Reports.vue'),
		},
		{
			path: '/backup_logs',
            name: 'backup_logs',
            component: () => import('./modules/kit_digital/infra/BackupLogs.vue'),
		},
		{
			path: '/guidelines-list',
			name: 'guidelines-list',
			component: () => import('./views/GuidelinesList.vue'),
			beforeEnter: staff_or_loginas,
		},
		{
			path: '/guideline-editor/:guideline_id?',
			name: 'guideline-editor',
			component: () => import('./views/GuidelineEditor.vue'),
			beforeEnter: staff_or_loginas,
			props: true
		},
		{
			path: '/:companydb_id/other-doc-detail/:other_document_id',
			name: 'other-doc-detail',
			component: () => import('./views/OtherDocDetail.vue'),
			//beforeEnter: staff_only
			props: true
		},
		{
			path: '/:companydb_id/product-list',
			name: 'product-list',
			component: () => import('./views/ProductList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/remittance-list',
			name: 'remittance-list',
			component: () => import('./views/RemittanceList.vue'),
			props: true
		},
		{
			// Operativa interna: solo staff. No depende de una company
			// concreta (cobramos a TODOS los clientes de Coneptum en una
			// misma remesa), por eso la URL no lleva companydb_id. El
			// slug es opaco a propósito para no cantar "SEPA admin" en
			// logs/historial; la seguridad real la da `staff_only`.
			path: '/ops/b2b-payday',
			name: 'ops-b2b-payday',
			component: () => import('./views/SepaB2bRemittanceAdmin.vue'),
			beforeEnter: staff_only,
		},
		{
			path: '/:companydb_id/invoice-history-list',
			name: 'invoice-history-list',
			component: () => import('./modules/facturae/infra/InvoiceHistoryLogList.vue'),
			props: true
		},
		{
			path: '/kpi_errors',
			name: 'kpi-errors',
			component: () => import('./views/KPIDocErrors.vue'),
			beforeEnter: staff_only
		},
		{
			path: '/access-registers',
			name: 'access-registers',
			component: () => import('./views/AccessRegistersList.vue'),
			props: true
			// beforeEnter: staff_only
		},
		{
			path: '/onboard-information',
			name: 'onboard-information',
			component: () => import('./views/OnboardInformation.vue'),
			props: true,
			beforeEnter: onboard_allowed_only,
		},
		{
			path: '/users-permissions',
			name: 'users-permissions',
			component: () => import('./views/UsersPermissions.vue'),
			props: true
			// beforeEnter: staff_only
		},

		// {
		// 	path: '/speach-loader',
		// 	name: 'speach-loader',
		// 	component: () => import('./views/SpeachLoader.vue')
		// },
		{
			path: '/:companydb_id/document-loader',
			name: 'document-loader',
			component: () => import('./views/DocumentLoader.vue')
		},
		{
			path: '/:companydb_id/documents', 
			name: 'document-list',
			component: () => import('./views/DocumentList.vue'),
			// children:[
			// 	{
			// 		path: 'documents',
					
			// 		//props: true
			// 	}
			// ]
		},


		{
			path: '/:companydb_id/generic-document-loader',
			name: 'generic-document-loader',
			props: true,
			component: () => import('./views/GenericDocumentLoader.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users
		},
		{
			path: '/:companydb_id/generic-documents/', 
			name: 'generic-document-list',
			props: true,
			component: () => import('./views/GenericDocumentList.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},
		{
			path: '/:companydb_id/invoice-approval-flows',
			name: 'invoice-approval-flows',
			props: true,
			component: () => import('./views/InvoiceApproval.vue'),
			meta: { invoiceApprovalAccess: { viewAction: 'approval_settings_manage' } },
		},
		{
			path: '/:companydb_id/invoice-approvals/:approval_id?',
			name: 'invoice-approvals',
			props: true,
			component: () => import('./views/InvoiceApproval.vue'),
			meta: { invoiceApprovalAccess: { viewAction: 'approval_view' } },
		},
		{
			path: '/:companydb_id/workflow-list',
			name: 'workflow-list',
			props: true,
			component: () => import('./views/WorkflowList.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},
		{
			path: '/:companydb_id/workflow-editor/:workflow_id?',
			name: 'workflow-editor',
			props: true,
			component: () => import('./views/WorkflowEditor.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},
		{
			path: '/:companydb_id/entities-list',
			name: 'entities-list',
			props: true,
			component: () => import('./views/EntitiesList.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},
		{
			path: '/:companydb_id/entities-list-v0/:entity_type_id?',
			name: 'entities-list2',
			props: true,
			component: () => import('./views/EntitiesListUIs.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},// sergi
		{
			path: '/:companydb_id/entity-type-editor/:entity_type_id?',
            name: 'entity-type-editor',
            props: true,
            component: () => import('./views/EntityTypeEditor.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},

		{
			path: '/:companydb_id/entity-instance-editor/:entity_instance_id?',
			name: 'entity-instance-editor',
			props: true,
			component: () => import('./views/EntityInstanceEditor.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},
		{
			path: '/:companydb_id/8dad4dd4-6c00-564e-ad23-3ae3142a12a4/instances',
			name: 'zero-coma-edas-neo',
			props: route => ({ companyId: Number(route.params.companydb_id) }),
			component: () => import('./modules/zero_coma/infra/ZeroComaEdasNeoView.vue'),
		},
		{
			path: '/:companydb_id/:entity_type_uuid/instances',
			name: 'entity-instances',
			props: true,
			component: () => import('./views/EntityInstancesView.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},
		{
			path: '/:companydb_id/:entity_type_uuid/singleton/:entity_instance_id?',
			name: 'entity-singleton',
			props: (route) => ({
				companydb_id: route.params.companydb_id,
				entity_type_id: route.params.entity_type_uuid,
				entity_instance_id: route.params.entity_instance_id || null,
				singleton: true
			}),
			component: () => import('./views/EntityInstanceEditor.vue'),
			beforeEnter: hide_restricted_modules_for_albaran_users,
		},

		{
			path: '/:companydb_id/invoice-template-playground',
			name: 'invoice-template-playground',
			props: true,
			component: () => import('./views/InvoiceTemplatePlayground.vue'),
			beforeEnter: staff_or_loginas
		},

		// {
		// 	path: '/documents-suppliers',
		// 	name: 'document-list-suppliers',
		// 	component: () => import('./views/DocumentList.vue'),
		// 	props: true
		// },
		// {
		// 	path: '/documents-customers',
		// 	name: 'document-list-customers',
		// 	component: () => import('./views/DocumentList.vue'),
		// 	props: true,
		// },
		{
			path: '/:companydb_id/documents/:document',
			name: 'document-detail',
			component: () => import('./views/DocumentDetailWrapper.vue'),
			props: true
		},
		{
			path: '/:companydb_id/deleted-documents/',
			name: 'deleted-documents',
			component: () => import('./views/DeletedDocumentList.vue'),
			props: true
		},
		{
			path: '/document-stats',
			name: 'document-stats',
			component: () => import('./views/DocumentStats.vue')
		},
		// {
		// 	path: '/companies',
		// 	name: 'company-list',
		// 	component: () => import('./views/CompanyList.vue'),
		// 	props: true
		// },
		// {
		// 	path: '/create-company',
		// 	name: 'company-create',
		// 	component: () => import('./views/CreateCompany.vue'),
		// 	props: true
		// },
		// {
		// 	path: '/companies/:company',
		// 	name: 'company-update',
		// 	component: () => import('./views/CreateCompany.vue'),
		// 	props: true
		// },
		{
			path: '/:companydb_id/suppliers',
			name: 'supplier-list',
			component: () => import('./views/SupplierList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/create-supplier',
			name: 'supplier-create',
			component: () => import('./views/CreateSupplier.vue'),
			props: true
		},
		{
			path: '/:companydb_id/suppliers/:supplier',
			name: 'supplier-update',
			component: () => import('./views/CreateSupplier.vue'),
			props: true
		},
		{
			path: '/:companydb_id/customers',
			name: 'customer-list',
			component: () => import('./views/CustomerList.vue'),
			props: true
		},
		{
			path: '/bank-creation',
			name: 'bank-creation',
			component: () => import('./views/AfterbanksWidget.vue'),
			props: true
		},
		{
			path: '/bank-redirect',
			name: 'bank-redirect',
			component: () => import('./views/BankRedirect.vue'),
			props: true
		},
		{
    	path: '/stripe-result/:stripe_result?/',
			name: 'stripe-result',
			component: () => import('./views/StripeResult.vue'),
			props: true
		},
		{
			path: '/:companydb_id/bank-accounts',
			name: 'bank-accounts',
			component: () => import('./views/BankAccountList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/bank-accounts/:bank_account_id/',
			name: 'bank-transactions',
			component: () => import('./views/BankTransactionList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/bank-accounts/:bank_account_id/reconciliation',
			name: 'bank-reconciliation',
			component: () => import('./views/BankReconciliation.vue'),
			props: true
		},
		{
			path: '/:companydb_id/create-bank-accounts',
			name: 'create-bank-accounts',
			component: () => import('./views/CreateBankAccount.vue'),
			props: true
		},
		{
			path: '/:companydb_id/effects',
			name: 'bank-effects',
			component: () => import('./views/BankEffectList.vue'),
			props: true
		},
		{
			path: '/:companydb_id/create-customer',
			name: 'customer-create',
			component: () => import('./views/CreateCustomer.vue'),
			props: true
		},
		{
			path: '/:companydb_id/customers/:customer',
			name: 'customer-update',
			component: () => import('./views/CreateCustomer.vue'),
			props: true
		},
		{
			path: '/:companydb_id/invoice-customers',
			name: 'invoice-customers',
			component: () => import('./views/InvoiceCustomersView.vue'),
			props: true
		},
		{
			path: '/:companydb_id/invoice-suppliers',
			name: 'invoice-suppliers',
			component: () => import('./views/InvoiceSuppliersView.vue'),
			props: true
		},
		{
			path: '/debug',
			name: 'debug',
			component: () => import('./views/Debug.vue'),
			props: true,
			beforeEnter: staff_only_or_staff_loginas,
		},
		{
			path: '/loginas/:username',
			name: 'loginas-debug',
			component: () => import('./views/Debug.vue'),
			props: true,
			beforeEnter: staff_only_or_staff_loginas,
		},
		{
			path: '/debug_distribuidor',
			name: 'debug-distribuidor',
			component: () => import('./views/DebugDistribuidor.vue'),
			props: true,
			beforeEnter: distribuidor_avanzado_only,
		},
		{
			path: '/select_upgrade_create',
			name: 'select-upgrade-create',
			component: () => import('./views/SelectUpgradeCreateContract.vue'),
			props: true,
		},
		{
			path: '/create_contract',
			name: 'create-contract',
			component: () => import('./views/CreateNewContract.vue'),
			props: true,
		},
		{
			path: '/upgrade_contract',
			name: 'upgrade-contract',
			component: () => import('./views/UpgradeContract.vue'),
			props: true,
		},
		{
			path: '/create_upgrate_contract',
			name: 'create-upgrate-contract',
			component: () => import('./views/CreateUpgrateContract.vue'),
			props: true,
		},
		{
			path: '/payment_error',
			name: 'payment-error-dashboard',
			component: () => import('./views/DashboardCompanyDB.vue')
			
		},
		{
			path: '/payment_ok',
			name: 'payment-ok-dashboard',
			component: () => import('./views/DashboardCompanyDB.vue')
		},
		{
			path: '/performing-update',
			name: 'performing-update',
			component: () => import('./views/PerformingUpdate.vue')
		},
		{
			path: '/performing-updates',
			name: 'performing-updates',
			component: () => import('./views/PerformingUpdateV2.vue')
		},
		{
			path: '/network-drives',
			name: 'network-drives',
			component: () => import('./views/NetworkDrives.vue'),
			props: true
		},
		{
			path: '/settings',
			name: 'settings',
			component: () => import('./views/Config.vue'),
			props: true
		},
		{
			path: '/locations',
			name: 'locations',
			component: () => import('./views/Location.vue'),
			props: true
		},
		{
			path: '/oauth/:app',
			name: 'oauth-flow',
		},
		{
			path: '/responsible-declaration',
			name: 'responsible-declaration',
			component: () => import('./views/ResposibleDeclaration.vue'),
			props: true
		},
		{
			path: '/signin_by_token/:token/:company_id',
            name: 'login-token',
            component: () => import('./modules/users/infra/LoginToken.vue'),
			// beforeEnter: staff_only,
			props: true
		},
		{
			path: '/signin/:company_id',
            name: 'login-signin',
            component: () => import('./modules/users/infra/LoginToken.vue'),
			// beforeEnter: staff_only,
			props: true
		},
		{
			path: '/cargar_empresa/:companydb_type/:code',
			name: 'load-company',
			component: () => import('./modules/company/infra/LoadCompany.vue'),
			props: true
		},
		{
			path: '/contractsKPI',
			name: 'contractsKPI',
			component: () => import('./views/ContractsKPI.vue'),
			props: true,
			beforeEnter: contracts_kpi_allowed_only,
		},
		{
			path: '/:companydb_id/working-hours',
			name: 'WorkingHours',
			component: () => import('@/modules/working_hours/infra/WorkingHours.vue'),
			props: true
		},
		{
			path: "/:companydb_id/working-hours-history",
			name: "WorkingHoursHistory",
			component: () => import("@/modules/working_hours/infra/WorkingHoursHistory.vue"),
			meta: { requiresAuth: true },
			props: true
		},
		{
			path: '/:companydb_id/working-hours-absences',
			name: 'WorkingHoursAbsences',
			component: () => import('@/modules/working_hours/infra/WorkingHoursAbsences.vue'),
			meta: { requiresAuth: true },
			props: true
		},
		{
			path: '/:companydb_id/working-hours-admin-month',
			name: 'AdminMonthView',
			component: () => import('@/modules/working_hours/infra/WorkingHoursAdminMonth.vue'),
			meta: { requiresAuth: true },
			props: true
		},
		{
			path: '/:companydb_id/working-hours-admin-users',
			name: 'AdminUserManagement',
			component: () => import('@/modules/working_hours/infra/AdminUserManagement.vue'),
			meta: { requiresAuth: true },
			props: true
		},
		{
			path: '/:companydb_id/working-hours-config',
			name: 'WorkingHoursConfig',
			component: () => import('@/modules/working_hours/infra/WorkingHoursConfig.vue'),
			meta: { requiresAuth: true },
			props: true
		},
		{
			path: '/:companydb_id/working-hours-holidays',
			name: 'WorkingHoursHolidays',
			component: () => import('@/modules/working_hours/infra/WorkingHoursHolidays.vue'),
			meta: { requiresAuth: true },
			props: true
		},
		// {
		// 	path: '/biel',
		// 	name: 'biel',
		// 	component: () => import('./views/BielPlayGround.vue'),
		// 	props: true,
		// 	beforeEnter: staff_only,
		// },
		{
			path: '/narcis',
			name: 'narcis',
			component: () => import('./views/NarcisPlayground.vue'),
			props: true,
			beforeEnter: staff_only,
		},
		{
			path: '/:companydb_id/claude-playground',
			name: 'claude-playground',
			component: () => import('./views/ClaudeVibeComponentPlayground.vue'),
			props: true,
			beforeEnter: staff_only,
		},
		{
			path: '/:companydb_id/agent-chat',
			name: 'agent-chat',
			component: () => import('./views/AgentChat.vue'),
			props: true,
			beforeEnter: staff_only,
		},
		{
			path: '/agent-maker',
			name: 'agent-maker',
			component: () => import('./views/AgentMaker.vue'),
			beforeEnter: staff_only,
		},
		{
			path: '/user_stats',
			name: 'user-redis-stats',
			component: () => import('./views/UserRedisStats.vue'),
			beforeEnter: staff_only_or_staff_loginas,
		},
		{
			path: '/global_stats',
			name: 'global-redis-stats',
			component: () => import('./views/GlobalRedisStats.vue'),
			beforeEnter: staff_only_or_staff_loginas,
		},
		{
			path: '/supplier-prompts-ai',
			name: 'supplier-prompts-ai',
			component: () => import('./views/SupplierPromptsAI.vue'),
			beforeEnter: staff_only_or_staff_loginas,
		},

		// {
		// 	path: '/chat-stats',
		// 	name: 'chat-stats',
		// 	component: () => import('./views/ChatStats.vue')
		// },
		// {
		// 	path: '/call-log',
		// 	name: 'call-log',
		// 	component: () => import('./views/CallLog.vue')
		// },
		// {
		// 	path: '/speech-analytics',
		// 	name: 'speech-analytics',
		// 	component: () => import('./views/SpeechAnalytics.vue')
		// },
		// {
		// 	path: '/live-chats',
		// 	name: 'live-chats',
		// 	component: () => import('./views/LiveChats.vue')
		// },
	]
});

function getDistribInnuvaURL(params, name, url) {
	let stateParam = params.get('state');
	const newStateValue = stateParam.replace('_'+name, '');
	params.set('state', newStateValue);
	const newURL = url + `innuva_oauth#${params.toString()}`;
	window.location.href = newURL;
	return;
}

// Cooldown between update-triggered reloads so we never enter a reload loop if
// the served frontend still mismatches the override (e.g. a manual override
// without an Amplify cutover). 30s is enough for the cutover to settle.
const UPDATE_RELOAD_COOLDOWN_MS = 30000;
const UPDATE_RELOAD_TS_KEY = 'inmatic_update_reload_ts';

/**
 * If the heartbeat flagged that the API endpoint was switched to a different
 * backend, perform a full cache-busting reload (equivalent to Ctrl+F5) so the
 * browser fetches the new frontend build (index.html + hashed assets).
 *
 * The reload targets the DESTINATION route (`to.fullPath`), not the current
 * URL: beforeEach runs before Vue Router updates the browser URL, so
 * window.location.href is still the origin page here.
 *
 * @param   {Route} to  the destination route of the current navigation
 * @returns {boolean}   true if a reload was triggered (navigation should abort)
 */
function reloadForUpdateIfPending (to) {
	if (!HeartbeatService.isUpdateAvailable()) return false;
	try {
		const last = parseInt(sessionStorage.getItem(UPDATE_RELOAD_TS_KEY) || '0', 10);
		if (Date.now() - last < UPDATE_RELOAD_COOLDOWN_MS) return false;
		sessionStorage.setItem(UPDATE_RELOAD_TS_KEY, String(Date.now()));
	} catch (e) { /* sessionStorage may be unavailable; proceed anyway */ }
	const dest = (to && to.fullPath) ? to.fullPath : '/';
	const url = new URL(window.location.origin + dest);
	url.searchParams.set('r', Math.floor(Math.random() * 1e9));
	window.location.replace(url.toString());
	return true;
}

router.beforeEach(async (to, from, next) => {
	try {
		// Blue/green cutover: if the heartbeat has redirected this tab's API
		// endpoint to a different backend, force a full reload on the next
		// navigation so the matching frontend build is fetched. Done in the
		// guard (not mid-task) so it never interrupts the user.
		if (reloadForUpdateIfPending(to)) return;

		if ('/innuva_oauth' == to.path) {
			const currentURL = window.location.href;
			const hashParams = currentURL.split('#')[1];
			const params = new URLSearchParams(hashParams);
			const stateParam = params.get('state');
			if (stateParam.includes('_docunecta')) {
				// const newStateValue = stateParam.replace('_docunecta', '');
				// params.set('state', newStateValue);
				// const newURL = `https://docuxtract.docunecta.com/innuva_oauth#${params.toString()}`;
				// window.location.href = newURL;
				// return;
				return getDistribInnuvaURL(params, 'docunecta', 'https://docuxtract.docunecta.com/')
			} else if (stateParam.includes('_glasof')) {
				return getDistribInnuvaURL(params, 'glasof', 'https://gscan.glasof.com/')
			} else if (stateParam.includes('oxigen')) {
				return getDistribInnuvaURL(params, 'oxigen', 'https://portal.oxigendc.com/')
			} else if (stateParam.includes('novantia')) {
				return getDistribInnuvaURL(params, 'novantia', 'https://app.novantiaeconomistas.es/')
			} else if (stateParam.includes('gestoriamoro')) {
				return getDistribInnuvaURL(params, 'gestoriamoro', 'https://app.gestoriamoro.com/')
			}
		}
		await store.dispatch('waitForLoggedIn')
		if (store.state.isLogged == 'no') {
			if (!['login', 'signup','signup-2','password-reset', 'password-reset-key','white_brand', 'report-invoice','report-invoice-dynamic','report-otorgamiento','login-token','tarifas','bank-claim-doc'].includes(to.name)) {
				if (to.name == 'home' && "about_expiry" in to.query) {
					try {
						sessionStorage.setItem('inmatic_about_expiry', true)
					} catch(e) {}
				}
				next('/login');				
			} else {
				next();
			}
		} else {
			await store.dispatch('me/refreshUserData');
			let userData = store.getters['me/userData'];
			let session_information = store.state.session_information;
			const invoiceApprovalRedirect = await resolveInvoiceApprovalAccessRedirect(
				to,
				companyId => store.dispatch('permissions/loadInvoiceApprovalAccess', companyId),
			);
			if (invoiceApprovalRedirect) {
				next(invoiceApprovalRedirect);
				return;
			}
			const albaranAccessRedirect = await resolveAlbaranAccessRedirect(
				to,
				companyId => store.dispatch('permissions/loadAlbaranAccess', companyId),
			);
			if (albaranAccessRedirect) {
				next(albaranAccessRedirect);
				return;
			}
			const nominaAccessRedirect = await resolveNominaAccessRedirect(
				to,
				companyId => store.dispatch('permissions/loadNominaAccess', companyId),
				code => store.getters.got_feature(code),
			);
			if (nominaAccessRedirect) {
				next(nominaAccessRedirect);
				return;
			}
			if ('/innuva_oauth' == to.path) {
				let hash = to.hash;
				if (hash[0]=='#') {
					hash = hash.substring(1);
				}
				let oauth_params = { 'params': hash };
				let state = await store.dispatch('connector/setOauthData', oauth_params);
                let redirect_uri = '/create-connector';
				if (state.match('^\\/\\d+\\/[\\w-]+$')) redirect_uri = state;
                next({
                    path: redirect_uri,
				});
			} 
			else if ('oauth-flow' == to.name) {
				let oauth_params = {'params':to.query ,'type': to.params.app};
				let state = await store.dispatch('setOauthDataStorage', oauth_params);
                let redirect_uri = `/connector/${state}`;
                next({
                    path: redirect_uri,
				});
			}
			else if (store.getters['me/userData'].is_staff) {
				next();
			} else if (userData.available_features.feature_performing_update && to.path != '/performing_update' && !(userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))) {
				next('/performing_update');
			} else if (store.getters['me/pendingEmailVerification'] && to.path != '/confirm-email' && !(userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))) {
				next('/confirm-email')
			} else if (store.getters['me/isWelcomeProcess'] && to.path != '/welcome' && !(userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))) {
				next('/welcome');
			} else if (
				isFichajesOnly(userData) &&
				!isWorkingHoursPath(to.path) &&
				!['/login', '/logout', '/change_password', '/profile', '/welcome', '/performing_update', '/confirm-email', '/tarifas'].includes(to.path)
			) {
				// Why: tras login, currentCompany aún no está hidratado. El array
				// state.companydbs ya viene poblado con las companies a las que el
				// usuario tiene acceso real, así que cogemos la primera. Caer a '1'
				// llevaba a usuarios sin acceso a la company 1 a la pantalla de trial.
				const firstCompanyDb = (store.state.companydbs && store.state.companydbs[0]) || null;
				const companyId = to.params.companydb_id ||
					(store.state.currentCompany && store.state.currentCompany.id) ||
					(firstCompanyDb && firstCompanyDb.id);
				if (!companyId) {
					next();
					return;
				}
				next(`/${companyId}/working-hours`);
			} else if (to.path == '/performing_update' && !userData.available_features.feature_performing_update) {
				next('/initial');
			} else if (['/login', '/signup'].includes(to.path)) {
				next('/initial');
			} else if (to.path == '/confirm-email' && !store.getters['me/pendingEmailVerification']) {				
				next('/initial');
			} else if (to.path == '/welcome' && !store.getters['me/isWelcomeProcess']) {
				next('/initial');
			} else if (to.path == '/debug' && !(store.getters['me/userData'].is_staff || (userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username)))) {
				next('/initial');
			} else if (to.path == '/debug_distribuidor' && !canAccessDebugDistribuidor(userData)) {
				next('/initial');
			} else if (['/create_upgrate_contract', '/payment_error', '/payment_ok'].includes(to.path) && !userData.available_features.feature_payment_on_inmatic) {
				next('/initial');
			} else {
				next();
			}
		}
	} catch {
		next();
	}
});

// El indicador de «cambiando de empresa» del módulo de nóminas lo apagan las propias
// pantallas al montarse. Si el usuario acaba en otra parte —el guard lo desvía, o pulsa
// otra cosa mientras carga— nadie lo apagaría y la próxima visita al módulo empezaría
// con un «Cargando…» que no espera nada.
router.afterEach((to) => {
	if (shouldCancelNominaTransition(to.name)) {
		finishNominaViewTransition();
	}
});

export default router;
